import CategoryCollectionPage from './CategoryCollectionPage';
import { LASY_CONFIG } from './categoryPageConfigs';
export default function LasyWSzklePage() {
  return <CategoryCollectionPage config={LASY_CONFIG} />;
}
